module.exports = __webpack_public_path__ + "static/media/3-1-mobile.a162b3cb.webp";